import { render, staticRenderFns } from "./SpuModify.vue?vue&type=template&id=6cc48948"
import script from "./SpuModify.vue?vue&type=script&lang=js"
export * from "./SpuModify.vue?vue&type=script&lang=js"
import style0 from "./SpuModify.vue?vue&type=style&index=0&id=6cc48948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports